import personalnyjTrener from "shared/assets/professions/personalnyj-trener.svg";
import nutritsiolog from "shared/assets/professions/nutritsiolog.svg";
import instruktorPoDetskomu from "shared/assets/professions/instruktor-po-detskomu.svg";
import instruktorPoPilatesu from "shared/assets/professions/instruktor-po-pilatesu.svg";
import spetsPoDvizheniyu from "shared/assets/professions/spets-po-dvizheniyu.svg";
import nutritsiologiyaIadapPitanie from "shared/assets/courses/nutritsiologiya-i-adap_pitanie.svg";
import biomekhanic from "shared/assets/courses/biomekhanic.svg";
import metodikiLfkIreab from "shared/assets/courses/metodiki-lfk-i-reab.svg";
import farmakologiya from "shared/assets/courses/farmakologiya.svg";
import detskijFitnes from "shared/assets/courses/detskij-fitnes.svg";
import { wrapUrlWithCurrentQuery } from "common";

const professions = [
  {
    title: "Персональный тренер",
    duration: "6 месяцев",
    image: personalnyjTrener,
    category: "Профессия",
    link: wrapUrlWithCurrentQuery("https://pt.bodycoach.pro/"),
  },
  {
    title: "Нутрициолог",
    duration: "6 месяцев",
    image: nutritsiolog,
    category: "Профессия",
    link: wrapUrlWithCurrentQuery("https://nutritionist.bodycoach.pro/"),
  },
  {
    title: "Инструктор по детскому фитнесу",
    duration: "6 месяцев",
    image: instruktorPoDetskomu,
    category: "Профессия",
    link: wrapUrlWithCurrentQuery(
      "https://academy.bodycoach.pro/training/category/professii"
    ),
  },
  {
    title: "Инструктор по пилатесу",
    duration: "6 месяцев",
    image: instruktorPoPilatesu,
    category: "Профессия",
    link: wrapUrlWithCurrentQuery(
      "https://academy.bodycoach.pro/training/category/professii"
    ),
  },
  {
    title: "Специалист по движению и оздоровительным технологиям",
    duration: "6 месяцев",
    image: spetsPoDvizheniyu,
    category: "Профессия",
    link: wrapUrlWithCurrentQuery(
      "https://academy.bodycoach.pro/training/category/professii"
    ),
  },
];

const courses = [
  {
    title: "Нутрициология и адаптивное питание",
    duration: "14 дней",
    image: nutritsiologiyaIadapPitanie,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/99"),
  },
  {
    title: "Биомеханика и техника выполнения силовых упражнений",
    duration: "1 месяц",
    image: biomekhanic,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/137"),
  },
  {
    title: "Методики ЛФК и реабилитации",
    duration: "21 день",
    image: metodikiLfkIreab,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/100"),
  },
  {
    title: "Фармакология в фитнесе и бодибилдинге",
    duration: "14 дней",
    image: farmakologiya,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/117"),
  },
  {
    title: "Детский фитнес",
    duration: "14 дней",
    image: detskijFitnes,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/104"),
  },
  {
    title: "Построение тренировочного процесса. Научный подход",
    duration: "14 дней",
    image: instruktorPoDetskomu,
    category: "Курс",
    link: wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/buy/109"),
  },
];

export const allEvents = [
  {
    title: "Профессии",
    value: "professions",
    elements: professions,
    buttonText: "Показать ещё профессии",
    buttonLink: wrapUrlWithCurrentQuery(
      "https://academy.bodycoach.pro/training/category/professii"
    ),
    description:
      "Большие учебные программы с кураторской поддержкой и экзаменационной работой для освоения новой специальность с нуля",
  },
  {
    title: "Курсы",
    value: "courses",
    elements: courses,
    buttonText: "Показать ещё курсы",
    buttonLink: wrapUrlWithCurrentQuery(
      "https://academy.bodycoach.pro/training/category/platnye-obucheniya"
    ),
    description: "Короткие программы для изучения конкретного направления",
  },
];
